/**
 * ARIA-status en scroll-lock voor de zoekmodal.
 *
 * TWEE TAKEN
 *
 * 1. aria-expanded op het zoekveld laten meebewegen met of de dropdown open
 *    staat. Zonder dat meldt een screenreader permanent 'samengevouwen'
 *    terwijl er resultaten zichtbaar zijn.
 *
 * 2. De scroll-lock opheffen als de modal sluit.
 *
 *    Het thema zet bij het openen de class 'js-scroll-lock' op de body
 *    (assets/utils-body-lock.js) en haalt hem er bij het sluiten weer af.
 *    Op mobiel bleef die class staan na het wegklikken van de zoekmodal: de
 *    pagina was dan bevroren tot een refresh.
 *
 *    De open- en sluitlogica zit in extenders-search-bar.js. Dat bestand is
 *    119 KB en bevat naast de UI ook de resten van de Algolia-integratie;
 *    we raken het niet aan. Vermoedelijk vindt de sluitfunctie het
 *    invoerveld niet meer sinds daar hidden inputs en een label voor staan
 *    en type='text' naar type='search' ging.
 *
 *    Daarom hier een vangnet dat naar het resultaat kijkt in plaats van naar
 *    de oorzaak.
 *
 * LET OP: de lock wordt alleen opgeheven als er verder niets anders open
 * staat. De cart drawer, het filterpaneel en de mobiele navigatie gebruiken
 * dezelfde class; die mogen we niet per ongeluk ontgrendelen.
 *
 * Kan weg zodra search-bar.js wordt vervangen; dan hoort dit in de
 * sluitfunctie zelf.
 */
(function () {
  'use strict';

  var modal = document.getElementById('search-modal');
  if (!modal) return;

  var inputs = document.querySelectorAll('.search-bar__input');

  /* Selectors van andere overlays die dezelfde scroll-lock gebruiken. Staat
     er nog eentje open, dan laten we de lock met rust. */
  var OTHER_OVERLAYS = [
    '.cart-drawer.is-open',
    '.cart-drawer[aria-hidden="false"]',
    '.mobile-navigation.is-open',
    '.mobile-navigation[aria-hidden="false"]',
    '.modal-overlay[aria-hidden="false"]',
    '.filter-overview[aria-hidden="false"]',
    'quick-add-modal[aria-hidden="false"]'
  ];

  function somethingElseIsOpen() {
    for (var i = 0; i < OTHER_OVERLAYS.length; i++) {
      try {
        if (document.querySelector(OTHER_OVERLAYS[i])) return true;
      } catch (e) {
        /* ongeldige selector negeren */
      }
    }
    return false;
  }

  function isOpen() {
    if (modal.getAttribute('aria-hidden') === 'false') return true;
    var s = getComputedStyle(modal);
    return s.visibility === 'visible' && s.opacity !== '0';
  }

  var last = null;

  function sync() {
    var open = isOpen();
    if (open === last) return;
    last = open;

    Array.prototype.forEach.call(inputs, function (el) {
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (!open && !somethingElseIsOpen()) {
      document.body.classList.remove('js-scroll-lock');
    }
  }

  new MutationObserver(sync).observe(modal, {
    attributes: true,
    attributeFilter: ['aria-hidden', 'class', 'style']
  });

  /* Extra vangnet: klikken op de sluitknop of op Escape. De MutationObserver
     vuurt pas als het attribuut daadwerkelijk verandert, en als search-bar.js
     dat niet doet zou de lock alsnog blijven staan. */
  function forceUnlock() {
    setTimeout(function () {
      if (!isOpen() && !somethingElseIsOpen()) {
        document.body.classList.remove('js-scroll-lock');
      }
    }, 350);
  }

  Array.prototype.forEach.call(document.querySelectorAll('.search-bar__close'), function (btn) {
    btn.addEventListener('click', forceUnlock);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') forceUnlock();
  });

  sync();
})();
